export default {
  // Page metadata  
  'meta.title': 'Terms of Service - timer.today',
  'meta.description': 'Terms of Service and usage agreement for timer.today online timing tools platform. Learn about our service rules, user rights and responsibilities.',
  
  // Page header
  'page.title': 'Terms of Service',
  'page.lastUpdated': 'Last updated: {{date}}',
  'page.intro': 'Welcome to timer.today. These terms and conditions outline the rules and regulations for the use of timer.today\'s Website, located at timer.today.',

  // Section 1
  'section1.title': '1. Acceptance of Terms',
  'section1.content': 'By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.',

  // Section 2  
  'section2.title': '2. Service Description',
  'section2.intro': 'timer.today provides free online timing tools including:',
  'section2.timer': 'Countdown Timer - Customizable timer for productivity, cooking, and time management',
  'section2.stopwatch': 'Stopwatch - High-precision timing tool for sports, training, and precise timing',
  'section2.worldclock': 'World Clock - Real-time display of global time zones',

  // Section 3
  'section3.title': '3. Use License',
  'section3.intro': 'Permission is granted to temporarily use timer.today for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:',
  'section3.item1': 'modify or copy the materials',
  'section3.item2': 'use the materials for any commercial purpose or for any public display',
  'section3.item3': 'attempt to reverse engineer any software contained on the website',
  'section3.item4': 'remove any copyright or other proprietary notations from the materials',

  // Section 4
  'section4.title': '4. Privacy and Data',
  'section4.intro': 'timer.today is committed to protecting your privacy:',
  'section4.item1': 'We do not collect or store personal information',
  'section4.item2': 'Timer settings are stored locally in your browser',
  'section4.item3': 'We do not track user behavior or usage patterns',
  'section4.item4': 'No cookies are used for tracking purposes',

  // Section 5
  'section5.title': '5. Disclaimer',
  'section5.content': 'The materials on timer.today are provided on an \'as is\' basis. timer.today makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.',

  // Section 6
  'section6.title': '6. Limitations',
  'section6.content': 'In no event shall timer.today or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on timer.today, even if timer.today or its authorized representative has been notified orally or in writing of the possibility of such damage.',

  // Section 7
  'section7.title': '7. Accuracy of Materials',
  'section7.content': 'The materials appearing on timer.today could include technical, typographical, or photographic errors. timer.today does not warrant that any of the materials on its website are accurate, complete, or current. timer.today may make changes to the materials contained on its website at any time without notice.',

  // Section 8
  'section8.title': '8. Modifications',
  'section8.content': 'timer.today may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.',

  // Section 9
  'section9.title': '9. Contact Information',
  'section9.intro': 'If you have any questions about these Terms of Service, please contact us at:',
  'section9.email': 'Email:',
  'section9.emailSubject': 'Terms of Service Inquiry - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. All rights reserved.'
};